import { Home } from "@/pages/home";
import BaseV2 from "@/layout/v2/base";
import { PageTagihanV2, PageTagihanDetailV2 } from "@/pages/InfoPelanggan/v2";

const { createBrowserRouter, Navigate } = require("react-router-dom");
const { Midleware, Base, Auth, NotFound } = require("@/layout");
const { AuthRouter, TagihanRouter } = require("./public");
const { TagihanRouterV2 } = require("./public/v2");

export const routerApp = createBrowserRouter([
    {
        path: '/',
        element: <Midleware isProtected={false} render={<BaseV2 />}/>,
        children: [
            {
                index: true,
                element: <Navigate to="/info-tagihan" />
            },
            {
                path: 'info-tagihan',
                element: <PageTagihanV2 />
            },
            {
                path: 'info-tagihan/:id',
                element: <PageTagihanDetailV2 />
            },
            ...TagihanRouterV2
        ]
    },
    {
        path: '/old',
        element: <Midleware isProtected={false} render={<Base />}/>,
        children: [
            ...TagihanRouter
        ]
    },
    {
        path: 'auth',
        element: <Midleware isProtected={false} render={<Auth />}/>,
        children: [
            // Public Routes
            ...AuthRouter,
        ]
    },
    {
        path: "*",
        element: <NotFound />,
    },
])